import React from "react";
import {List, ListItem, ListItemIcon, ListItemText} from "@mui/material";
import copita_tap from "../../assets/images/kozel_meet/copita_tap.png";
import copita_tap_contrast from "../../assets/images/kozel_meet/copita_tap_contrast.png";
import useListInfoStyles from "../../styles/kozel/listInfo";

interface ListItemProps {
    text: string
}

interface ListInfoProps {
    items: ListItemProps[],
    hasContrast?: boolean,
}

const ListInfo: React.FC<ListInfoProps> = ({items, hasContrast}) => {
    const listInfoStyles = useListInfoStyles();
    return (
        <List className={listInfoStyles.contentTeaserList}>
            {items.map((item, index) => (
                <ListItem key={index} className={listInfoStyles.contentTeaserListItem}>
                    <ListItemIcon>
                        {hasContrast ?
                            <img src={copita_tap_contrast} alt={'copita_tap_contrast'}/>  :
                            <img src={copita_tap} alt={'copita_tap'}/>
                        }
                    </ListItemIcon>
                    <ListItemText primary={item.text} className={hasContrast ? 'contrast' : ''}/>
                </ListItem>
            ))}
        </List>
    )
}

export default ListInfo;